import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";
import { Slot } from "./slotBonds";

export const slotsApi = api
  .enhanceEndpoints({ addTagTypes: ["slot-bonds"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      slotBonds: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/slot-bonds`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: { data: any[] }) =>
          response.data.map<Slot>((slot: any) =>
            snakeToCamel({
              ...slot,
              start_date: slot.start_date,
              end_date: slot.end_date,
              start_time: slot.time_start,
              end_time: slot.time_end,
              fees: slot.fees?.split(","),
            })
          ),
        providesTags: ["slot-bonds"],
      }),
    }),
  });

export const {
  useSlotBondsQuery,
} = slotsApi;
